export default () => ({
  openDialog() {
    const dropzone = this.$root.querySelector('.dz-clickable')

    dropzone.click()
  },
})
